import { Injectable } from '@angular/core';
import { AnalyticsData } from './analytics.model';
import { UserService } from '../user/user.service';
import { User } from '../user/user.model';

declare var dataLayer;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService{

  constructor(private userService : UserService){

  }

  pushData(analyticsData : AnalyticsData){
    let user : User=this.userService.getUser();
    if(!analyticsData){
      analyticsData=new AnalyticsData();
    }
    if(user){
      analyticsData.UserID=user.id;
      analyticsData.CompanyID=user.companyID;
      analyticsData.CompanyUID=user.companyUID;
      analyticsData.UserProfile=user.userType;
      dataLayer.push(analyticsData.toJson());
    }

  }

  pushEventData(data : any){
    dataLayer.push(data);
  }

  pushEvent(event : string){
    let analyticsData={'event' : event, 'Webapp':'Spectrum'};
    dataLayer.push(analyticsData);
  }

  pushTitleClickEvent(){
      this.pushEvent('titleClick');
  }

  pushUpgradeButtonClickEvent(){
    this.pushEvent('upgradeButtonClick');
  }

  pushUpgradeFormClickEvent(){
    this.pushEvent('upgradeFormSubmited');
  }
}
